export function getCurrentPage( page, totalPages ) {

    let maxNum;

    if( totalPages < 5 ) {
        maxNum = totalPages - page;
    }

    page = parseInt(page);
    totalPages = parseInt(totalPages);

    switch( page ) {
        case 1: return setPagination( 0, maxNum !== undefined ? maxNum : 4, page );
        case 2: return setPagination( 1, maxNum !== undefined ? maxNum : 3, page  );
        case 3: return setPagination( 2, maxNum !== undefined ? maxNum : 2, page  );
        case 4: return setPagination( 3, maxNum !== undefined ? maxNum : 1, page  );
        case totalPages: return setPagination( 4, 0, page  );
        case totalPages - 1: return setPagination( 3, 1, page  );
        default: return setPagination( 2, 2, page );
    }

}

export function setPagination( minimum, maximum, page ) {

    const prevPage = page - 1;

    const nextPage = page + 1;

    const min = (page - minimum);

    const max = (+page + +maximum);

    const pages = { min, max, prevPage, nextPage }

    return pages;

}

export function setCurrentPage( param, totalPages ) {

    let currentPage;

    if( !param || param > totalPages ){
        currentPage = 1;
    }else{
        currentPage = param;
    }

    return currentPage;

}

export function getPageNumbers( paginationRange ) {

    let pageNumbers = [];

    for(let i = paginationRange.min; i < paginationRange.max + 1; i++){
        pageNumbers.push(i);

    }

    return pageNumbers;

}




// WEBPACK FOOTER //
// src/client/helpers/paginationHelpers.js